import { useState, useEffect, useCallback } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import api from '../api/client';
import TeacherStudentActivityJournal from '../components/TeacherStudentActivityJournal';
import { studentLabel } from '../utils/studentLabel';
import { useStudentTabIdentity } from '../hooks/useTabIdentity';

export default function TeacherStudentActivityPage() {
  const { studentId } = useParams();
  const navigate = useNavigate();
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useStudentTabIdentity(overview?.student ?? null, 'активность');

  const loadOverview = useCallback(async () => {
    if (!studentId) return;
    setLoading(true);
    setError('');
    try {
      const res = await api.get(`/teacher/students/${studentId}/overview/`);
      setOverview(res.data);
    } catch (e) {
      const msg = e.response?.data?.detail || e.response?.data?.message || 'Не удалось загрузить данные ученика.';
      setError(typeof msg === 'string' ? msg : 'Не удалось загрузить данные ученика.');
      setOverview(null);
    } finally {
      setLoading(false);
    }
  }, [studentId]);

  useEffect(() => {
    void loadOverview();
  }, [loadOverview]);

  const handleSelectTask = (slug) => {
    if (!slug) return;
    navigate(`/teacher/students/${studentId}`, { state: { selectTaskSlug: slug } });
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Загрузка...</p>
      </div>
    );
  }

  if (error || !overview) {
    return (
      <div className="teacher-student-work-page error-state">
        <p>{error || 'Ученик не найден.'}</p>
        <Link to="/teacher" className="btn btn-outline">В кабинет преподавателя</Link>
      </div>
    );
  }

  const studentName = studentLabel(overview.student);
  const myLists = Array.isArray(overview.task_lists) ? overview.task_lists : [];
  const otherLists = Array.isArray(overview.other_teacher_task_lists) ? overview.other_teacher_task_lists : [];
  const selfLists = Array.isArray(overview.student_self_task_lists) ? overview.student_self_task_lists : [];

  return (
    <div className="teacher-student-work-page teacher-student-activity-page">
      <header className="teacher-student-work-header">
        <Link to={`/teacher/students/${studentId}`} className="back-link">← Работа с учеником</Link>
        <h1>Журнал активности</h1>
        <span className="text-secondary">{studentName} (@{overview.student.username})</span>
      </header>

      <div className="teacher-activity-page-body">
        <TeacherStudentActivityJournal
          studentId={studentId}
          myLists={myLists}
          otherLists={otherLists}
          selfLists={selfLists}
          onSelectTaskSlug={handleSelectTask}
        />
      </div>
    </div>
  );
}
